import React from 'react';
import { motion } from 'framer-motion';
import { RecycleIcon, LeafIcon, PenToolIcon } from 'lucide-react';
export function ProductDetail() {
  return <section id="product" className="py-24 md:py-32 px-4 bg-white" data-id="element-150">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 lg:gap-20 items-center" data-id="element-151">
        {/* Left: Copy */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-152">
          <div className="text-xs uppercase tracking-[0.25em] text-green font-medium" data-id="element-153">
            The Birdie Bag
          </div>

          <h2 className="font-display text-4xl md:text-6xl font-bold leading-tight text-charcoal" data-id="element-154">
            Everything
            <br data-id="element-155" />
            You Need.
          </h2>

          <p className="text-lg text-charcoal/70 leading-relaxed max-w-md" data-id="element-156">
            Thoughtfully designed for sustainability, made to move with you. A
            complete reusable straw set, housed in a handcrafted mini golf bag.
          </p>

          <div className="space-y-5 pt-6 border-t border-stone" data-id="element-157">
            <div className="flex items-center gap-4 text-charcoal/80" data-id="element-158">
              <div className="w-10 h-10 rounded-full bg-sage/30 flex items-center justify-center flex-shrink-0" data-id="element-159">
                <RecycleIcon className="w-5 h-5 text-green" data-id="element-160" />
              </div>
              <span className="text-base" data-id="element-161">
                Reusable for life — never single-use
              </span>
            </div>
            <div className="flex items-center gap-4 text-charcoal/80" data-id="element-162">
              <div className="w-10 h-10 rounded-full bg-sage/30 flex items-center justify-center flex-shrink-0" data-id="element-163">
                <LeafIcon className="w-5 h-5 text-green" data-id="element-164" />
              </div>
              <span className="text-base" data-id="element-165">
                Plant-based caddy, made in Europe
              </span>
            </div>
            <div className="flex items-center gap-4 text-charcoal/80" data-id="element-166">
              <div className="w-10 h-10 rounded-full bg-sage/30 flex items-center justify-center flex-shrink-0" data-id="element-167">
                <PenToolIcon className="w-5 h-5 text-green" data-id="element-168" />
              </div>
              <span className="text-base" data-id="element-169">
                Personalize with engraving — up to 8 characters
                <span className="text-green font-medium" data-id="element-170"> (+£4.99)</span>
              </span>
            </div>
          </div>

          {/* Family Pack upgrade */}
          <div className="mt-4 p-6 rounded-2xl bg-cream border border-stone" data-id="element-171">
            <div className="flex items-baseline gap-3 mb-2 flex-wrap" data-id="element-172">
              <h3 className="font-display text-xl font-bold text-charcoal" data-id="element-173">
                Family Pack
              </h3>
              <span className="text-sm font-medium text-green" data-id="element-174">+ £4.99</span>
            </div>
            <p className="text-charcoal/70 leading-relaxed text-base" data-id="element-175">
              Upgrade to a full set of 7 stainless steel straws and a dedicated
              cleaning brush — share the sustainable sip with the whole family.
            </p>
          </div>
        </motion.div>

        {/* Right: Image */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="rounded-2xl overflow-hidden shadow-sm" data-id="element-176">
          <img src="https://cdn.magicpatterns.com/uploads/tn4npM9cJe9GTJNWL6rjXQ/ChatGPT_Image_Jun_4,_2026,_02_39_04_PM.png" alt="Birdie Bag full set — caddy, straws, and cleaning brush" className="w-full h-auto block" data-id="element-177" />
        </motion.div>
      </div>
    </section>;
}